import React from 'react';
import { InView } from 'react-intersection-observer';

import LazyImgixImage from '@components/LazyImgixImage';
import useEventTracking from '@hooks/useEventTracking';
import {
  ClickTarget,
  ImpressionElement,
  Page,
  TrackingLocation,
  click,
  impression,
} from '@tracking';

import { TITVPartnerAd } from './interfaces';

const Partners = ({ partnerAds }: { partnerAds: TITVPartnerAd[] }) => {
  const { trackEvent } = useEventTracking({
    page: Page.TITV,
    location: TrackingLocation.TITVAdPartner,
  });

  return (
    <InView
      triggerOnce={true}
      onChange={(inView) => {
        inView &&
          trackEvent(impression({ impressionElement: ImpressionElement.FeaturedPartnerAd }));
      }}
    >
      <section
        className="mt-40 w-full border-0 border-t border-solid border-grayscale-charcoal"
        data-testid="titv-partner-logo"
      >
        <h3 className="mb-40 mt-12 font-suisse-intl-mono text-overline-lg font-normal">
          Supported by
        </h3>
        <div className="flex flex-col flex-wrap items-start justify-start gap-32 sm:flex-row sm:items-end">
          {partnerAds.map((partnerAd) => (
            <a
              key={partnerAd.name}
              className="min-w-min"
              href={partnerAd.trackingLink}
              onClickCapture={() =>
                trackEvent(
                  click({
                    clickTarget: ClickTarget.Logo,
                    clickText: partnerAd.name,
                  })
                )
              }
              rel="noreferrer sponsored"
              target="_blank"
              data-testid={`titv-partner-logo-${partnerAd.name}`}
            >
              <LazyImgixImage
                src={partnerAd.logo}
                alt={`${partnerAd.name} logo`}
                className="max-h-40 w-auto"
                wrapperClassName="w-full"
              />
            </a>
          ))}
        </div>
      </section>
    </InView>
  );
};

export default Partners;
